import { render, staticRenderFns } from "./SDK.vue?vue&type=template&id=68a8a0ee&"
import script from "./SDK.vue?vue&type=script&lang=js&"
export * from "./SDK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports